const measureDisplayMode = {
    text: 1,
    graph: 2
}

export default measureDisplayMode;